<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<p-dialog #importexcel id="importexcel"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '70vw', height: '50hw'}">

  <ng-template pTemplate="content" *ngIf="document">
    <div class="grid formgrid fluid">
      <p-accordion [multiple]="true" class="col">
        <p-accordionTab header="Источник данных" [selected]="openFileSelector">
          <p-tabView class="mt-2" [(activeIndex)]="tabIndex" (onChange)="onTabChange($event)" appStopAccordionHomeEnd>
            <p-tabPanel header="Выбор документа" [cache]="false" [disabled]="false">
              <ng-template pTemplate="header">
                <i class="pi pi-plus mr-2"></i>
                <span>Загрузка из файла</span>
              </ng-template>
              <div class="col-6 sm:col-12 mt-2 mr-2">
                <input type="file" (change)="onFileChange($event)" accept=".xls,.xlsx" [multiple]="false" />
              </div>
              <!--<div class="col-6 sm:col-12 mt-2 mr-2">
                <p-fileUpload mode="basic" accept=".xls,.xlsx" [maxFileSize]="10000000" label="Import" chooseLabel="Import"
                              customUpload="true" [auto]="true" (onProgress)="onProgress($event)"
                              (onUpload)="onBasicUpload($event)" class="mr-4 "></p-fileUpload>
              </div>-->
            </p-tabPanel>

            <p-tabPanel header="Paste from clipboard" [cache]="false" [disabled]="false">
              <ng-template pTemplate="header">
                <i class="pi pi-sitemap mr-2"></i>
                <span>Вставка из буфера копирования</span>
              </ng-template>
              <textarea pInputTextarea [(ngModel)]="textSource" class="col-12" [style]="{height: '150px'}"></textarea>

              <div class="grid p-jc-between">
                <div class="col-2 mt-2">
                  <p-radioButton name="groupname" value="tab" label="TAB разделители" [(ngModel)]="textType" (onClick)="onTextTypeClick($event)"></p-radioButton>
                </div>
                <div class="col-2 mt-2">
                  <p-radioButton name="groupname" value="csv" label="CSV файл" [(ngModel)]="textType" (onClick)="onTextTypeClick($event)"></p-radioButton>
                </div>

                <div class="col-4 mt-2"></div>

                <p-button label="Вставить данные" (onClick)="onInsertText($event)" class="mt-2 mb-2 mr-2" [disabled]="!canInsertTextData"></p-button>
              </div>

            </p-tabPanel>
          </p-tabView>
        </p-accordionTab>

        <p-accordionTab header="Сопоставление полей" [selected]="openFieldSelector">

          <div class="grid formgrid fluid" appStopAccordionHomeEnd>

            <div class="col-3 xl:col-3 sm:col-6 mb-2" *ngFor="let fld of paramsMap">
              <h5>{{fld.fieldLabel}}</h5>
              <div class="fluid">
                <p-dropdown [options]="columns" [(ngModel)]="fld.importColumnName" [autofocusFilter]="false" [showClear]="!fld.fieldIsMandatory" [autoDisplayFirst]="false" [required]="fld.fieldIsMandatory"></p-dropdown>
              </div>
            </div>

            <div class="col-3 xl:col-3 sm:col-6 mb-2" *ngIf="processDateField">
              <h5>Обработка даты: {{selectedDateProcess}}</h5>
              <div class="fluid">
                <p-dropdown [options]="dateProcessType" [autofocusFilter]="false" [(ngModel)]="selectedDateProcess"></p-dropdown>
              </div>
            </div>

          </div>

          <p-table #sourceTable id="sourceTable"
                   appStopAccordionHomeEnd
                   [columns]="columns"
                   [value]="dataSource"
                   [paginator]="true"
                   [rows]="10"
                   [showCurrentPageReport]="true"
                   styleClass="p-datatable p-datatable-sm p-datatable-gridlines p-datatable-striped p-datatable-customers mt-2 mb-2">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [class.met]="columnMet(col)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                  {{col}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td *ngFor="let col of columns" [class.met]="columnMet(col)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                  {{rowData[col]}}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="col-12 grid " appStopAccordionHomeEnd>
            <div class="p-field-checkbox col-4 ">
              <p-checkbox [(ngModel)]="clearBefore" [binary]="true" inputId="shc"></p-checkbox>
              <label for="shc">Очистить существующие</label>
            </div>
            <div class="p-field-checkbox col-4">
              <p-checkbox [(ngModel)]="overwriteExisted" [binary]="true" inputId="shd"></p-checkbox>
              <label for="shd">Обновлять существующие</label>
            </div>
            <div class="p-field-checkbox col-4">
              <p-checkbox [(ngModel)]="addExisted" [binary]="true" inputId="shi" (onChange)="onShowItemChange($event)"></p-checkbox>
              <label for="shi">Добавлять к существующим</label>
            </div>
          </div>

          <div class="grid formgrid justify-content-end">
            <p-button label="Вставить данные" (onClick)="onDataInsert($event)" class="mt-2 mb-2 mr-2" [disabled]="!canInsertData"></p-button>
          </div>
        </p-accordionTab>

        <p-accordionTab header="Импорт данных" [selected]="openImportResult">
          <app-list-doc-items appStopAccordionHomeEnd
                              [docItems]="docItems"
                              [canSeeU4etka]="showU4etka"
                              [showQuantity]="showQuantity"
                              [showPrice]="showPrice"
                              [diText1Column]="diText1Column"
                              [diText2Column]="diText2Column"
                              [diText1ColumnName]="diText1ColumnLable"
                              [diText2ColumnName]="diText2ColumnLable"
                              [diU4ETKAColumnName]="diU4ETKAColumnName">
          </app-list-doc-items>
        </p-accordionTab>

      </p-accordion>

    </div>

  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (onClick)="onImportContent('ok')" [disabled]="notReady"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (onClick)="display=false"></p-button>
  </ng-template>
</p-dialog>
